import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/** Page-preview hosts subscribe and refetch `getCardData` for one card. */
@Injectable({ providedIn: 'root' })
export class CardRuntimeDataRefreshBroker {
	private readonly refreshRequested = new Subject<string>();

	readonly refreshRequested$ = this.refreshRequested.asObservable();

	requestRefresh(cardId: string): void {
		const id = cardId?.trim();
		if (!id) {
			return;
		}
		this.refreshRequested.next(id);
	}

	get hasListeners(): boolean {
		return this.refreshRequested.observed;
	}
}
